import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import ContratoEditor from "@/pages/admin/ContratoEditor";
import { pageHead } from "@/lib/seo";

const busca = z.object({ paciente: z.string().optional().catch(undefined) });

export const Route = createFileRoute("/admin/contratos/novo")({
  validateSearch: busca,
  head: () => pageHead({ title: "Novo contrato | Painel", path: "/admin/contratos/novo", noindex: true }),
  component: () => <ContratoEditor />,
});
